import { times } from 'lodash';

import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';

import LazyLoaderWrapper from 'atoms/LazyLoaderWrapper';

import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import {
  getDeliveryOrderStatusMessageString,
  isCreateOrAssignedOrStoreArrivalOrder,
  isDeliveryOrderArrivedOrder,
  isDeliveryOrderAssign,
  isDeliveryOrderCancelledOrRefund,
  isDeliveryOrderCreate,
  isDeliveryOrderDelivered,
  isDeliveryOrderDeliveredOrCancelledOrRefund,
  isDeliveryOrderIframeComponentsWithoutDelivered,
  isDeliveryOrderOutForDelivery,
  isDeliveryOrderPickedUp,
  isDeliveryOrderPOSCompleted,
  isDeliveryOrderStoreArrival,
  isPickedUpOrOutForOrArrivedOrder,
  isDasherDroppedOff,
  isCheckedInAbandoned,
  isDasherEnrouteToDropOff,
} from 'common/utilities/orderStatusUtils';

import OrderSummaryRaiderDetails from 'organisms/orderSummaryRaiderDetails/container/orderSummaryRaiderDetails';
import { HTTPS_URL, TOTAL_AMOUNT_REPLACE_TEXT } from 'common/constants/SharedConstants';
import { isSupportedTenantCode, isValidObject, displayPrice } from 'common/utilities/utils';
import {
  getStatusMessageFromContentful,
  getSubStatusMessageFromContentful,
  getCardFillRange,
  checkPaymentTextForRefund,
  hideEstimatedArraival,
  hideProgessBar,
} from 'common/utilities/orderDetailsUtils';

/*********************************************************************
 *
 *
 *********************************************************************/
export const getDeliveryEstimatedArrivalOrDeliveredAtPanelJSX = params => {
  const { orderDetails } = params;
  const {
    orderStatus,
    deliveryOrEstimatedOrCollectAtTime
  } = orderDetails;
  return (
    <>
      <div className={`estimated-arrival estimated-arrival-refund ${orderStatus}-delivery`}>
        {isDeliveryOrderDelivered(orderDetails)
          ? translateWithI18Next(TRANSLATE_MAPPING_KEY?.DELIVERED_AT)
          : translateWithI18Next(TRANSLATE_MAPPING_KEY?.ESTIMATED_ARRIVAL)}
      </div>
      {
        <div className='idAndTime time-delivery'>
          {orderDetails?.deliveryDetails?.actualDeliveryTime ? orderDetails?.deliveryOrActualOrCollectAtTime : deliveryOrEstimatedOrCollectAtTime}
        </div>
      }
    </>
  );
};

/*********************************************************************
 *
 *
 *********************************************************************/
export const checkIsDriverArrived = orderDetails => {
  const { orderSummarycontentData, total, currencySymbol, currencyConversionFactor } = orderDetails;
  const updatedSubHeadLine = orderSummarycontentData?.payOnArrivalSubheadline?.replace(
    TOTAL_AMOUNT_REPLACE_TEXT,
    `<span class="red">${displayPrice(total, { currencySymbol, currencyConversionFactor })}</span>`,
  );
  const updatedTextWithAmount = `<div class='subheadline-content'>${updatedSubHeadLine}</div>`;
  return isDasherEnrouteToDropOff(orderDetails)
    ? updatedTextWithAmount
    : orderSummarycontentData?.payOnArrivalSubheadline;
};

/*********************************************************************
 *
 *
 *********************************************************************/
const getDeliveryProgressBarJSX = params => {
  const { orderDetails } = params;
  const noOfProgressDiv = orderDetails?.requestedDateTime?.isForNow
    ? orderDetails?.orderTrackingProgressBarCount
    : orderDetails?.orderTrackingProgressBarScheduleOrdersCount;

  let card = [];

  const cardToFill = getCardFillRange(orderDetails);
  if (cardToFill !== 0) {
    times(noOfProgressDiv, i => {
      card.push(
        <div className={`ProgressDelivery Bar`} key={i}>
          <div
            className={`subProgressDelivery ${i < cardToFill ? (i === cardToFill - 1 && 'play') || 'full' : 'none'}`}
            key={i}
          ></div>
        </div>,
      );
    });
  }
  return cardToFill > 0 && cardToFill <= noOfProgressDiv && <div className='progress-bar-list col-12'>{card}</div>;
};

/*********************************************************************
 *
 *
 *********************************************************************/
const getDeliveryStatusIconJSX = params => {
  const { orderDetails } = params;
  const {
    orderStatus,
    orderSummarycontentData,
    enableRetryCountForPickupOrderTracking,
    enableClickCollectScheduleOrder,
  } = orderDetails;
  const { ConfirmedImg, TakeAwayImg, DeliveryTracker, DeliveryCart, CartError, TakeawayCompleted } = IMAGE_PATH;

  const imageSrcFn = () => {
    if (isDeliveryOrderPOSCompleted(orderDetails)) {
      return ConfirmedImg;
    } else if (isDeliveryOrderCreate(orderDetails)) {
      return TakeAwayImg;
    } else if (isDeliveryOrderAssign(orderDetails)) {
      return TakeawayCompleted;
    } else if (isDeliveryOrderStoreArrival(orderDetails)) {
      return TakeawayCompleted;
    } else if (isDeliveryOrderPickedUp(orderDetails)) {
      return DeliveryTracker;
    } else if (isDeliveryOrderOutForDelivery(orderDetails)) {
      return DeliveryTracker;
    } else if (isDeliveryOrderArrivedOrder(orderDetails)) {
      return DeliveryTracker;
    } else if (isDeliveryOrderDelivered(orderDetails)) {
      return DeliveryCart;
    } else if (isDeliveryOrderCancelledOrRefund(orderDetails)) {
      return CartError;
    }
    return ConfirmedImg;
  };
  const imageSrc =
    enableRetryCountForPickupOrderTracking && !enableClickCollectScheduleOrder
      ? orderSummarycontentData?.icon?.fields?.file?.url
      : imageSrcFn();

  return imageSrc !== '' && <img src={imageSrc} alt={orderStatus} />;
};

/*********************************************************************
 *
 *
 *********************************************************************/
const showOrderCancelMassage = () => {
  return isSupportedTenantCode() ? (
    <div className='allSet-delivery-refund'>
      {translateWithI18Next(TRANSLATE_MAPPING_KEY?.CANCELDELIVERYORDERREFUND)}
    </div>
  ) : (
    <div className='allSet-delivery-refund'>{`${translateWithI18Next(
      TRANSLATE_MAPPING_KEY?.CANCEL_ORDER_REFUND,
    )} ${15} ${translateWithI18Next(TRANSLATE_MAPPING_KEY?.BUSINESS_DAYS)}`}</div>
  );
};
const getDeliveryStatusMessageJSX = params => {
  const { orderDetails } = params;
  const { orderStatus, enableRetryCountForPickupOrderTracking, enableClickCollectScheduleOrder } = orderDetails;
  const statusMessage =
    enableRetryCountForPickupOrderTracking && !enableClickCollectScheduleOrder
      ? getStatusMessageFromContentful(orderDetails)
      : getDeliveryOrderStatusMessageString(orderDetails);
  const subStatusMessage =
    (isCheckedInAbandoned(orderDetails) || isDeliveryOrderCancelledOrRefund(orderDetails)) &&
    !enableClickCollectScheduleOrder
      ? checkPaymentTextForRefund(orderDetails)
      : getSubStatusMessageFromContentful(orderDetails);

  return (
    <div>
      {statusMessage !== '' && (
        <div
          className={`allSet allset-delivery ${orderStatus}-delivery-allSet col-12 ${
            isDeliveryOrderDeliveredOrCancelledOrRefund(orderDetails) ? '' : 'p-0px-imp'
          }`}
        >
          <span>{translateWithI18Next(statusMessage)}</span>
        </div>
      )}
      {subStatusMessage !== '' && !isDasherDroppedOff(orderDetails) && (
        <div className='substatusmsg' dangerouslySetInnerHTML={{ __html: subStatusMessage }}></div>
      )}
    </div>
  );
};

/*********************************************************************
 *
 *
 *********************************************************************/
const getDeliveryPartnerOTPPanelJSX = params => {
  const { orderDetails } = params;
  const { deliveryPartner, deliveryDetails } = orderDetails;
  const otp = deliveryPartner?.otp || deliveryDetails?.otp;
  return (
    !isDeliveryOrderPOSCompleted(orderDetails) &&
    otp && (
      <>
        <div className='estimated-arrival estimated-arrival-refund driver-msg col-12'>
          {translateWithI18Next(TRANSLATE_MAPPING_KEY?.ASK_FOR_OTP)}
        </div>
        <div className='idAndTime time-delivery'>
          <div className='red otp'>{otp}</div>
        </div>
      </>
    )
  );
};

/*********************************************************************
 *
 *
 *********************************************************************/
export const displayDeliveryStatusPanelJSX = params => {
  return (
    <>
      {!hideEstimatedArraival(params?.orderDetails) &&
        !isDeliveryOrderCancelledOrRefund(params?.orderDetails) &&
        getDeliveryEstimatedArrivalOrDeliveredAtPanelJSX(params)}
      {getDeliveryStatusIconJSX(params)}
      {!hideProgessBar(params?.orderDetails) && getDeliveryProgressBarJSX(params)}
      {getDeliveryStatusMessageJSX(params)}
      {getDeliveryPartnerOTPPanelJSX(params)}
    </>
  );
};

/*********************************************************************
 * Get Delivery Order Raider Details with Order Info View
 * params -
 *********************************************************************/
export const getDeliveryOrderRaiderDetailsWithOrderInfoViewJSX = params => {
  const { orderDetails } = params;
  return (
    <div
      className={`${
        isDeliveryOrderIframeComponentsWithoutDelivered(orderDetails)
          ? 'adjust-delivery-info bill-accordion-section'
          : 'bill-accordion-section'
      }`}
    >
      {getDeliveryOrderRaiderDetailsViewJSX(params)}
    </div>
  );
};

/*********************************************************************
 *  Get Delivery order Iframe panel
 *  params -
 *********************************************************************/
export const getDeliveryOrderIFramePanelJSX = params => {
  const { orderDetails } = params;
  const { deliveryPartner, deliveryDetails } = orderDetails;

  const getTrackingURL = () => {
    const trackingURL = deliveryPartner?.tracking_url || deliveryDetails?.deliveryTrackingUrl;
    return (trackingURL && trackingURL.indexOf(HTTPS_URL) === -1 ? HTTPS_URL : '') + trackingURL;
  };

  return (
    <iframe
      sandbox='allow-same-origin allow-scripts'
      className='iframe-ordertrackingmaps'
      title={translateWithI18Next(TRANSLATE_MAPPING_KEY?.TRACK_ORDER)}
      src={getTrackingURL()}
    ></iframe>
  );
};

/*********************************************************************
 *  Get Delivery Order Tracking using Google Map
 *  params -
 *********************************************************************/
export const getDeliveryOrderTrackingUsingGoogleMap = params => {
  const { deliveryAddress, store, deliveryDetails } = params?.orderDetails;

  if (isValidObject(store) && isValidObject(deliveryAddress)) {
    const storeLatLng = [store?.location?.latitude, store?.location?.longitude];
    const customerLatLng = [deliveryAddress?.location?.latitude, deliveryAddress?.location?.longitude];

    const getGoogleMap = props => {
      return (
        <LazyLoaderWrapper
          {...props}
          testId='appGoogleMap'
          importPath='APP_GOOGLE_MAP'
          orderTracking={true}
          storeLatLng={storeLatLng}
          customerLatLng={customerLatLng}
          raiderCurrentLatLng={deliveryDetails?.riderLocation}
          stylers={googleMapCustomStyler}
        ></LazyLoaderWrapper>
      );
    };

    return getGoogleMap(params);
  }
};

/*********************************************************************
 * Get Delivery Order Raider Details
 * params -
 *********************************************************************/
export const getDeliveryOrderRaiderDetailsViewJSX = params => {
  const { orderDetails } = params;
  return (
    (isCreateOrAssignedOrStoreArrivalOrder(orderDetails) || isPickedUpOrOutForOrArrivedOrder(orderDetails)) && (
      <OrderSummaryRaiderDetails {...params} />
    )
  );
};

export const googleMapCustomStyler = [
  {
    featureType: 'all',
    elementType: 'labels.text.fill',
    stylers: [
      {
        saturation: 36,
      },
      {
        color: '#202124',
      },
      {
        lightness: 40,
      },
    ],
  },
  {
    featureType: 'all',
    elementType: 'labels.text.stroke',
    stylers: [
      {
        visibility: 'off',
      },
      {
        color: '#202124',
      },
      {
        lightness: 16,
      },
    ],
  },
  {
    featureType: 'all',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#e3e3e3',
      },
      {
        lightness: 20,
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#e3e3e3',
      },
      {
        lightness: 17,
      },
      {
        weight: 1.2,
      },
    ],
  },
  {
    featureType: 'landscape',
    elementType: 'geometry',
    stylers: [
      {
        lightness: 20,
      },
    ],
  },
  {
    featureType: 'landscape.man_made',
    elementType: 'geometry',
    stylers: [
      {
        color: '#e3e3e3',
      },
      {
        lightness: 20,
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [
      {
        color: '#e3e3e3',
      },
      {
        lightness: 21,
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 17,
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 29,
      },
      {
        weight: 0.4,
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 18,
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'geometry',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 16,
      },
    ],
  },
  {
    featureType: 'transit',
    elementType: 'geometry',
    stylers: [
      {
        lightness: 19,
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [
      {
        lightness: 17,
      },
    ],
  },
];
